export default "__VITE_ASSET__DGx_tccB__"